<template>
  <v-stepper v-model="e1" elevation="0">
    <v-stepper-header class="elevation-0">
      <v-stepper-step class="pl-0 py-0" :complete="e1 > 1" step="1">
        {{ $t('BOOKING.CAPACITY.STEP_DESCRIPTION.TYPE') }}
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step class="py-0" :complete="e1 > 2" step="2">
        {{ $t('BOOKING.CAPACITY.STEP_DESCRIPTION.CAPACITY') }}
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step class="pr-0 py-0" step="3">
        {{ $t('BOOKING.CAPACITY.STEP_DESCRIPTION.COMPLETE') }}
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content class="pa-0" step="1">
        <v-card class="mx-auto" max-width="800" tile flat>
          <types-list
            :list="resourceTypes"
            @input="form.type_id = ($event || {}).id"
          />
          <v-card-actions class="px-0">
            <v-btn
              outlined
              depressed
              large
              color="grey"
              @click.prevent="$emit('cancel')"
            >
              {{ $t('BUTTON.CANCEL') }}
            </v-btn>

            <v-spacer />

            <v-btn
              depressed
              color="success"
              :disabled="!form.type_id"
              large
              @click="
                formChange();
                e1++;
              "
            >
              <div v-if="form.type_id === getDayResourceType">
                {{ $t('BUTTON.CREATE') }}
              </div>
              <div v-else>{{ $t('BUTTON.NEXT') }}</div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>

      <v-stepper-content class="pa-0" step="2">
        <v-card class="mx-auto" max-width="800" tile flat>
          <types-list
            :list="capacities"
            @input="form.capacity_type = ($event || {}).id"
          />
          <v-card-actions class="px-0">
            <v-btn
              outlined
              depressed
              large
              color="grey"
              @click.prevent="
                e1--;
                form.capacity_type = null;
              "
            >
              {{ $t('BUTTON.BACK') }}
            </v-btn>

            <v-spacer />

            <v-btn
              depressed
              color="success"
              :disabled="!form.capacity_type"
              large
              @click="
                formChange();
                e1++;
              "
            >
              <div v-if="form.capacity_type === getIndividualCapacityType">
                {{ $t('BUTTON.CREATE') }}
              </div>
              <div v-else>{{ $t('BUTTON.NEXT') }}</div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>

      <v-stepper-content class="pa-0" step="3">
        <v-card class="mx-auto" max-width="800" tile flat>
          <v-card-text class="pa-0">
            <v-form>
              <v-list-item class="pa-0" two-line>
                <v-list-item-content>
                  <v-list-item-title>{{
                      $t('BOOKING.CAPACITY.RESOURCE_CAPACITY.NAME')
                    }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                      $t('BOOKING.CAPACITY.RESOURCE_CAPACITY.DESCRIPTION')
                    }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-row>
                <v-col cols="5"><v-spacer /></v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model.number="form.capacity"
                    v-mask="'#####'"
                    min="1"
                    @keypress="numbersOnly"
                  ></v-text-field>
                </v-col>
                <v-col cols="5"><v-spacer /></v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-0">
            <v-btn
              outlined
              depressed
              large
              color="grey"
              @click.prevent="
                e1--;
                form.capacity = null;
              "
            >
              {{ $t('BUTTON.BACK') }}
            </v-btn>

            <v-spacer />

            <v-btn
              depressed
              color="success"
              :disabled="!form.capacity"
              large
              @click="formChange()"
            >
              {{ $t('BUTTON.CREATE') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mask } from 'vue-the-mask';
import TypesList from '@/modules/_global/_components/TypesList';
import { DAY, STEPPER_TYPES } from '@/modules/booking_resources/common/types';
import {
  CAPACITIES,
  INDIVIDUAL
} from '@/modules/booking_resources/common/capacity';
import { numbersOnly } from '@/modules/_global/utils/events';

export default {
  name: 'CapacityStepper',

  components: { TypesList },

  directives: {
    mask
  },

  data() {
    return {
      e1: 1,
      form: {
        type_id: null,
        capacity_type: null,
        capacity: null
      }
    };
  },

  computed: {
    getIndividualCapacityType() {
      return INDIVIDUAL;
    },
    getDayResourceType() {
      return DAY;
    },
    resourceTypes() {
      return STEPPER_TYPES.map(el => {
        return {
          id: el.id,
          name: this.$t(el.name),
          description: this.$t(el.description)
        };
      });
    },
    capacities() {
      return CAPACITIES.map(el => {
        return {
          id: el.id,
          name: this.$t(el.name),
          description: this.$t(el.description)
        };
      });
    }
  },

  methods: {
    formChange() {
      if (this.form.type_id === DAY || this.form.capacity_type === INDIVIDUAL) {
        this.form.capacity = 1;
        this.form.capacity_type = INDIVIDUAL;
      } else if (!this.form.capacity) {
        return;
      }

      this.$router.push({
        name: 'booking-resources.create',
        params: this.form
      });
    },
    numbersOnly
  }
};
</script>

<style scoped></style>
